var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "footer footer-section" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "footer-list" }, [
            _c("div", { staticClass: "footer-item" }, [
              _c("div", { staticClass: "footer-logo" }, [
                _c("img", {
                  attrs: { src: "/static/img/c_logo.png", alt: "" }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("WORLD SHINE DATA")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer-info" }, [
                _c("img", {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { src: "/static/img/footer_01.png", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "http://www.usoftchina.com",
                      target: "_blank"
                    }
                  },
                  [_vm._v("www.usoftchina.com")]
                ),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { "margin-left": "30px" },
                  attrs: { src: "/static/img/footer_02.png", alt: "" }
                }),
                _vm._v(" "),
                _c("a", [_vm._v("400-850-8585")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "company-logo" }, [
              _c("img", {
                attrs: { src: "/static/img/usoft_weixin_qr2.png", alt: "" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("华商数据公众号")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278c512f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278c512f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = null
// module chunks = 